import {Component} from '@angular/core';
import {TermsComponent} from '../../shared/terms/terms.component';
import {AuthService} from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  imports: [
    TermsComponent
  ]
})
export class AuthComponent {
  constructor(private authService: AuthService) {
  }

  login() {
    // this.oidcSecurityService.authorize();
    this.authService.login();
  }

  logout() {
    // localStorage.clear();
    // window.location.href = 'https://us-east-1lzcp6vacy.auth.us-east-1.amazoncognito.com/logout?client_id=sip37n6f41hmd1fmesonrck9b&logout_uri=http://localhost:4200/auth/logoff';
    this.authService.logout();
  }
}
